import RoutesPath from '@router/routes';

const routes = [
  {
    path: RoutesPath.private.faq.list,
    label: 'Lista de FAQ',
  },
  {
    path: RoutesPath.private.faq.create,
    label: 'Cadastro de FAQ',
  },
];

export default routes;
